import { getActionTypesForService } from 'shared/utils/createServiceStore.js';
import { PIPELINES_SERVICE_KEY } from './pipelinesEnum.js';

export default getActionTypesForService(PIPELINES_SERVICE_KEY);
